<template>
  <div class="newSmanage">
    <el-tabs class="tab" v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="文章" name="ManageNews"></el-tab-pane>
      <el-tab-pane label="公告" name="NoticeS"></el-tab-pane>
    </el-tabs>
    <div class="head-content">
      <el-button type="primary" @click="addNew">新增文章</el-button>
    </div>
    <el-table :data="newsList" style="width: 100%">
      <el-table-column prop="id" label="id" width="100"> </el-table-column>
      <el-table-column prop="article_title" label="标题"> </el-table-column>
      <el-table-column
        prop="article_author"
        label="作者"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="article_summary"
        label="简介"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="article_type"
        label="文章类型"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="article_active"
        label="是否发布"
        width="100"
        :formatter="article_active_atFormatter"
      ></el-table-column>
      <el-table-column
        prop="created_at"
        label="创建日期"
        :formatter="created_atFormatter"
        width="200"
      ></el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small"
            >查看</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="goEdit(scope.row)"
            v-if="scope.row.article_active ? false : true"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        @current-change="currentChangeHandle"
        :current-page="currentPage"
        layout=" prev, pager, next"
        :total="total"
        v-if="total"
        background
      ></el-pagination>
    </div>
    <el-dialog
      title="文章详情"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <div>
        <el-row>
          <el-col :span="2">标题 :</el-col>
          <el-col :span="20">{{ articleObj.article_title }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="2">简介 :</el-col>
          <el-col :span="22">{{ articleObj.article_summary }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="2">作者 :</el-col>
          <el-col :span="20">{{ articleObj.article_author }}</el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="2">内容 :</el-col>
        </el-row>
        <el-row>
          <div
            class="article_content"
            v-html="articleObj.article_content"
          ></div>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      total: 0,
      currentPage: 1,
      newsList: [],
      loading: false,
      dialogVisible: false,
      articleObj: {},
      activeName: 'ManageNews'
    }
  },
  methods: {
    article_active_atFormatter (row) {
      return row.article_active ? '是' : '否'
    },
    created_atFormatter (row) {
      return row.created_at.split('T').join(' ').split('+').shift()
    },
    handleClick (row) {
      setTimeout(() => {
        document.getElementsByClassName('el-dialog__wrapper')[0].scrollTop = 0
      }, 0)
      this.dialogVisible = true
      this.articleObj = row
      console.log(row)
    },
    tabClick (tab, event) {
      switch (tab.name) {
        case 'ManageNews':
          console.log('文章')
          break
        case 'NoticeS' :
          this.$router.push({
            path: './NoticeS'
          })
          break
        default: console.log('123')
      }
    },
    // 新增文章
    addNew (row) {
      this.$router.push({
        path: './addManageNews'
      })
    },
    // 跳转编辑
    goEdit (row) {
      this.$router.push({
        path: './editManageNews',
        query: {
          id: row.id
        }
      })
    },
    // 跳转文章详情页
    lookwz (id) {
      this.$router.push({
        path: './Article_details',
        query: {
          id: id
        }
      })
    },
    currentChangeHandle (val) {
      this.currentPage = val
      console.log(val)
      sessionStorage.setItem('currentPage', val)
      this.getNewSList(val)
    },
    getNewSList (page) {
      this.loading = true
      this.http.queryManageNews({type: '1400', page: page}).then(res => {
        this.loading = false
        this.total = res.data.data.total_page * 10
        this.newsList = res.data.data.article_list
        this.$scrollTo()
      })
    }
  },

  mounted () {
    if (sessionStorage.getItem('editManageNews')) {
      // console.log(Number(sessionStorage.getItem("currentPage")));
      // 如果有这个就读取缓存里面的数据
      this.currentPage = Number(sessionStorage.getItem('currentPage'))
    } else {
      this.currentPage = 1
      // 这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
      sessionStorage.removeItem('currentPage')
    }
    this.getNewSList(this.currentPage)
  },
  destroyed () {
    sessionStorage.removeItem('editManageNews')
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
.newSmanage {
  .tab {
    margin: 10px 20px 0px;
  }
  .head-content {
    padding: 20px;
  }
  .page {
    text-align: center;
    margin: 30px 0;
  }
  /deep/ .el-dialog__body {
    color: #cecde9 !important;
    background: #100e2e;
  }
  .article_content {
    padding: 10px 15px;
    background: #0d0b26;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manage/newsPage/index.vue